import React from 'react';

// Components
import {FormPageLayout} from "../components/layout/FormPageLayout";
import {LoginFeature} from "../features/login";
import {NAVIGATION_BAR_HEIGHT} from "../designSystem/tokens/spacing";

const LoginPage = () => (
  <FormPageLayout
    height={NAVIGATION_BAR_HEIGHT.LARGE}
    body={
      <LoginFeature />
    }
  />
);

export default LoginPage;
